import { StoreSync } from "@/elements-react/product-area/store/sync";

export class IconResolver {
  public registry: Record<string, string>;
  public sync: StoreSync;
  public loading: Set<string>

  public static instance = new IconResolver();

  constructor() {
    this.registry = this.createRegistry();
    this.loading = new Set<string>();
    this.sync = new StoreSync();
  }

  createRegistry() {
    const result = {} as Record<string, string>;

    return result;
  }

  async preload(urls: string[]) {
    const promises = urls.map(url => this.fetchResourse(url));

    await Promise.all(promises);
  }

  async preloadOne(url: string, key?: string) {
    await this.fetchResourse(url, key);
  }

  async fetchResourse(url: string, key?: string) {
    this.loading.add(url);

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch icon from ${url}`);
    }

    const svg = await response.text();

    this.setResourse(key ?? url, svg);
    this.sync.notify();
  }

  async setResourse(key: string, data: string) {
    this.registry[key] = data;
  }

  hasResourse(key: string) {
    return Boolean(this.registry[key]);
  }

  getResourse(url: string, key?: string) {
    if (!this.hasResourse(key ?? url) && !this.loading.has(url)) {
      this.fetchResourse(url, key);
    }

    return this.getResourceValue(key ?? url);
  }

  getResourceValue(key: string) {
    return this.registry[key] ?? null;
  }

  transformUrl(url: string) {
    if (import.meta.env.SSR) {
      return this.tranformUrlToRelativePath(url);
    }

    return url;
  }

  tranformUrlToRelativePath(url: string) {
    const pathMatch = url.match(/https?:\/\/[^\/]+(\/.+)/);

    if (pathMatch && pathMatch[1] && pathMatch.includes('/assets/')) {
      return `/assets/lib/default${pathMatch[1]}`;
    }

    return url;
  }

  createClientLibraryIconPath(name: string, library: string = "default") {
    return import.meta.env.BASE_URL + `assets/lib/${library}/${name}`
  }
}